import React from "react";
import { StatusPill } from "../../generic/Status/StatusPill";

const EnrolmentSupportStatusPill = ({ status }) => (
  <StatusPill status={status} />
);

export { EnrolmentSupportStatusPill };
